import axios from 'axios'

// eslint-disable-next-line
const localStorageKey = 'cs_user_data' + process.env.API_URL

const Authentication = {
  state: {
    token: null,
    user: {},
    config: {
      price_precision: 0,
      shop_address: {}
    }
  },
  getters: {
    isAuthenticated: (state) => {
      if (state.token) return true
      return false
    },
    getToken: (state) => state.token,
    getUser: (state) => state.user,
    getPricePrecision: (state) => state.config.price_precision,
    getShopAddress: (state) => state.config.shop_address
  },
  actions: {
    setAuth({ commit }, auth) {
      commit('setAuth', auth)
    },
    checkAuth({ commit }) {
      const data = JSON.parse(localStorage.getItem(localStorageKey))
      commit('setAuth', data)
    },
    logout({ commit }) {
      commit('logout')
    }
  },
  mutations: {
    setAuth(state, data) {
      if (data == null) {
        return
      }
      localStorage.setItem(localStorageKey, JSON.stringify(data))
      state.token = data.token
      state.user = data.user
      state.config = data.config
      axios.defaults.headers.Authorization = `Bearer ${state.token}`
    },
    logout(state) {
      localStorage.removeItem(localStorageKey)
      state.token = null
      state.user = {}
      state.config = {}
      axios.defaults.headers.Authorization = null
    }
  }
}

export default Authentication



// WEBPACK FOOTER //
// ./src/store/modules/authentication.js